/**
 * Discount Statistics Service
 * Manages discount usage statistics (mock for now, ready for API integration)
 */

const STORAGE_KEY = 'geppro_discount_stats';

// ============================================================
// Storage Helpers
// ============================================================
function loadStats() {
  try {
    const json = localStorage.getItem(STORAGE_KEY);
    return json ? JSON.parse(json) : {};
  } catch {
    return {};
  }
}

function saveStats(stats) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(stats));
  } catch (err) {
    console.error('Failed to save discount stats:', err);
  }
}

// ============================================================
// In-Memory Database
// ============================================================
const db = {
  stats: loadStats(),
};

// ============================================================
// Service Methods
// ============================================================
const discountStatsService = {
  /**
   * Get usage statistics for a discount
   * In production, this would call an API endpoint
   */
  async getDiscountStats(discountId) {
    return new Promise(resolve => {
      setTimeout(() => {
        const stats = db.stats[discountId] || {
          usageCount: Math.floor(Math.random() * 1000), // Mock data
          totalRevenue: Math.floor(Math.random() * 50000),
          lastUsedAt: new Date().toISOString(),
        };
        resolve(stats);
      }, 200);
    });
  },

  /**
   * Record a discount usage
   * In production, this would POST to an API endpoint
   */
  async recordUsage(discountId, amount) {
    return new Promise(resolve => {
      setTimeout(() => {
        const current = db.stats[discountId] || { usageCount: 0, totalRevenue: 0 };
        db.stats[discountId] = {
          usageCount: current.usageCount + 1,
          totalRevenue: current.totalRevenue + amount,
          lastUsedAt: new Date().toISOString(),
        };
        saveStats(db.stats);
        resolve({ success: true });
      }, 200);
    });
  },

  /**
   * API Integration Template
   * Replace the mock methods above with these when backend is ready:
   * 
   * async getDiscountStats(discountId) {
   *   const response = await fetch(`/api/discounts/${discountId}/stats`);
   *   return await response.json();
   * }
   * 
   * async recordUsage(discountId, amount) {
   *   const response = await fetch(`/api/discounts/${discountId}/usage`, {
   *     method: 'POST',
   *     headers: { 'Content-Type': 'application/json' },
   *     body: JSON.stringify({ amount }),
   *   });
   *   return await response.json();
   * }
   */
};

export default discountStatsService;
